// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/item/item.scss
// module id = 525
// module chunks = 0